<template>
  <div>
    <modal v-if="input" ref="modal" id="agInputModal" v-model="showModal"
      styles="display:flex; flex-direction:column; padding:15px;" name="input" content-class="modal-content"
      :draggable="true" :adaptive=true :resizable="true" :shiftX=.5 :shiftY=0 :fit-parent="true" :clickToClose="false"
      :key="reload" width="1114px" height="85%" drag="drag" resize="resize" :resize-directions="['br']"
      @keyup.enter.native="saveButton_click">
      <div>
        <h4 v-if="disableUI" class="agModal-title">View Input</h4>
        <h4 v-else class="agModal-title">Edit Input</h4>
        <hr />
      </div>
      <div class="inner" style="height: 100%; overflow-y: auto; overflow-x:hidden; position:relative;">
        <div class="agInputGroup agInputGroupCentered">
          <label>Source:</label>
          <b-input type="text" :value="srcStr" autocomplete="false" disabled></b-input>
        </div>
        <b-input-group style="padding:14px;" size="md" prepend="Name">
          <b-input type="text" v-model="input.name" autocomplete="false" :disabled="disableUI"></b-input>
        </b-input-group>
        <b-input-group style="padding:14px;" size="md" prepend="Description">
          <b-input type="text" v-model="input.description" autocomplete="false" :disabled="disableUI"></b-input>
        </b-input-group>
        <hr />
        <ag-fields-selector ref="fieldsSelector" :node="input" :disableUI="disableUI" :connections="connections"
          @refreshedSchemas="refreshedSchemas" @connectionChanged="connectionChanged" @layerChanged="layerChanged">
        </ag-fields-selector>
        <div v-if="showGeometry" class="agInputGroup agInputGroupCentered">
          <input type="checkbox" v-model="input.includeGeometry" :disabled="disableUI" />
          <label>Include geometry</label>
        </div>
        <div class="agInputGroup">
          <ag-sub-input style="padding:14px;" ref="wClause" :initText="wClauseString" @input="onChangeWclause"
            :workflow="workflow" :size="'md'" :prepend="'Where'" :appendButton="true" :buttonText="'Test'"
            :disabled="disableUI || disableWclause" @buttonClick="testWClause_click">
          </ag-sub-input>
          <!-- <ag-sub-input v-if="isPostgis" style="padding:14px;" ref="raw" :initText="rawString" @input="onChangeRaw"
            :workflow="workflow" :size="'md'" :prepend="'Raw'" :appendButton="true" :buttonText="'Test'"
            :disabled="disableUI || disableRaw" @buttonClick="testRaw_click">
          </ag-sub-input> -->
        </div>
        <label id="agInputModal-testMessage" :class="testMessageClass" @click="testMessage_click">{{ testMessage
          }}</label>
        <div v-if="queryParams.length > 0" class="agInputGroup">
          <label>Query Parameters:</label>
          <b-table id="agInputModal-queryParamsTable" :key="'queryParams-' + reloadQueryParams" :items="queryParams"
            :fields="queryParamHeaders" borderless outlined small>
            <template #cell(alias)="data">
              <b-input class="agInputModal-queryParamField" :value="data.value" autocomplete="false" disabled></b-input>
            </template>
            <template slot="=">
              <div class="agInputModal-queryParamEquals">=</div>
            </template>
            <template #cell(domain)="data">
              <b-form-select v-if="data.item.domain" v-model="data.item.value" class="agInputModal-queryParamValue"
                :options="data.item.domain" :disabled="disableUI || isUpdatingSchemas"
                @change="queryParamValue_change($event, data.index)">
              </b-form-select>
              <b-input v-else v-model="data.item.value" class="agInputModal-queryParamValue" type="text"
                autocomplete="false" :disabled="disableUI || isUpdatingSchemas">
              </b-input>
            </template>
          </b-table>
        </div>
        <hr />
        <div style="display:flex">
          <div class="agInputGroup agInputGroupCentered">
            <label>Result Destination:</label>
            <b-input type="text" :value="dest.shortname" autocomplete="false" disabled></b-input>
          </div>
          <b-form-checkbox id="dest2" name="checkbox-1" :checked="dest2.selected" @change="changeDest('dest2')"
            style="margin-top:4%" value=true unchecked-value=false></b-form-checkbox>
          <div class="agInputGroup agInputGroupCentered">
            <label>No Result Destination:</label>
            <b-input type="text" :value="dest2.shortname" autocomplete="false" disabled></b-input>
          </div>
          <b-form-checkbox id="dest3" :checked="dest3.selected" @change="changeDest('dest3')" name="checkbox-2"
            style="margin-top:4%" value=true unchecked-value=false></b-form-checkbox>
          <div class="agInputGroup agInputGroupCentered">
            <label>Error Destination:</label>
            <b-input type="text" :value="dest3.shortname" autocomplete="false" disabled></b-input>
          </div>
        </div>
        <div v-if="modalMessage">
          <hr />
          <label class="agModal-message" :class="modalMessageClass">{{
      modalMessage
    }}</label>
        </div>
        <hr />
      </div>
      <div>
        <hr />
        <b-button class="agModal-buttonLeft" @click="cancelButton_click">Cancel</b-button>
        <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
        <b-button style="margin-left:80%;" class="agModal-buttonRight" variant="danger"
          :disabled="disableUI || isLoading || isUpdatingSchemas" @click="deleteButton_click">Delete</b-button>
        <b-button style="float: right;" class="agModal-buttonRight" variant="primary"
          :disabled="disableUI || isLoading || isUpdatingSchemas" @click="saveButton_click">Save</b-button>
      </div>
    </modal>
    <!-- delete modal -->
    <b-modal class="agModal" ref="deleteModal" centered no-close-on-esc no-close-on-backdrop
      @keyup.enter.native="deleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Delete Input</h4>
      </template>
      Are you sure you want to delete input
      <i>{{ name }}</i>?
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button class="agModal-buttonRight" variant="danger" @click="confirmDeleteButton_click">Delete</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
// components
import SubInput from "comp/ui/SubInput";
import FieldsSelector from "comp/ui/FieldsSelector";
import _ from 'lodash';

// modules
import Server from "src/server";
import Util from "src/util/util";
import { EventBus } from "src/eventBus";

export default {
  name: "ag-input-modal",
  components: {
    "ag-sub-input": SubInput,
    "ag-fields-selector": FieldsSelector
  },
  props: {
    node: Object,
    workflow: Object,
    disableUI: Boolean,
  },
  data() {
    return {
      showModal: false,
      input: null,
      isPostgis: false,
      disableRaw: false,
      rawString: "",
      disableWclause: false,
      wClauseString: "",
      reload: 0,
      reloadQueryParams: 0,
      isLoading: false,
      isUpdatingSchemas: false,
      modalMessage: "",
      modalMessageClass: "",
      testMessage: "",
      testMessageClass: "",
      testRecords: [],
      queryParamHeaders: [
        { key: "alias", label: "Parameter" },
        { key: "=", label: "=" },
        { key: "domain", label: "Value" }
      ],
      queryParams: [],
      queryParamsCancel: null,
      showGeometry: false,
      dest: { shortname: null },
      dest2: { shortname: null, selected: false },
      dest3: { shortname: null, selected: false },
    };
  },
  computed: {
    name() {
      if (_.get(this.input, 'name')) {
        return this.input.name;
      }
      return _.get(this.input, 'shortname');
    },

    srcStr() {
      if (!this.input.src || this.input.src.length == 0) return "";

      var srcStr = "";
      for (var i = 0; i < this.input.src.length; i++) {
        var src = this.input.src[i];
        srcStr += src.shortname + ", ";
      }
      srcStr = srcStr.substring(0, srcStr.length - 2); // remove the last ,
      return srcStr;
    },

    connections() {
      var inputOutputConnections = this.$store.state.connStore.connections;
      if (this.input.connection) {
        let newConn = inputOutputConnections.find(c => c._id == this.input.connection._id)
        this.input.connection = newConn;
      }
      return inputOutputConnections.filter(c => c.type != "geometry").map(b => { return { value: b, text: b.name }; });
    }
  },

  watch: {
  },
  methods: {
    onChangeRaw(event) {
      this.rawString = event;
      if (_.size(this.rawString) > 0) {
        return this.disableWclause = true;
      } else {
        return this.disableWclause = false;
      }
    },
    onChangeWclause(event) {
      this.wClauseString = event;
      if (_.size(this.wClauseString) > 0) {
        return this.disableRaw = true;
      } else {
        return this.disableRaw = false;
      }
    },
    // UI Events
    changeDest(dest) {
      if (dest == "dest2") {
        if (this.dest2.selected) {
          this.dest2 = { shortname: null, selected: false }
        } else {
          this.dest2.selected = !this.dest2.selected
        }
      }
      else if (dest == "dest3") {
        if (this.dest3.selected) {
          this.dest3 = { shortname: null, selected: false }
        } else {
          this.dest3.selected = !this.dest3.selected
        }
      }
    },
    init() {
      console.log(_.get(this.node, 'object.connection.type'));
      if (_.get(this.node, 'object.connection.type') == "postgis") {
        this.isPostgis = true;
      } else {
        this.isPostgis = false;
        this.disableWclause = false;
      }
      this.wClauseString = this.input.wClause;
      this.rawString = this.input.raw;
      if(!this.isPostgis){
        this.rawString = "";
        this.input.raw = "";
      }
      if(_.size(this.wClauseString)>0 && _.size(this.rawString)>0){
          this.rawString = "";
          this.wClauseString = this.input.wClause;
          this.disableRaw = true;
          this.disableWclause = false;
        }else if(_.size(this.wClauseString)>0 && _.size(this.rawString)==0){
          this.rawString = "";
          this.wClauseString = this.input.wClause;
          this.disableRaw = true;
          this.disableWclause = false;
        }else if(_.size(this.wClauseString)==0 && _.size(this.rawString)>0){
          this.rawString = this.input.raw;
          this.wClauseString = "";
          this.disableRaw = false;
          this.disableWclause = true;
        }
        
      //init destObject with the prop data
      if (this.node.object.dest !== undefined) {
        this.dest = this.node.object.dest;
      }
      else {
        this.dest = { shortname: null }
      }
      if (this.node.object.dest2 !== undefined) {
        this.dest2 = this.node.object.dest2;
      }
      else {
        this.dest2 = { shortname: null, selected: false }
      }
      if (this.node.object.dest3 !== undefined) {
        this.dest3 = this.node.object.dest3;
      }
      else {
        this.dest3 = { shortname: null, selected: false }
      }
    },
    cancelButton_click() {
      this.$modal.hide('input');
    },
    hide(arg) {
      if (arg !== undefined) {
        this.$vfm.hide(arg);
      } else {
        this.$refs.modal.hide();
      }
    },
    async saveButton_click() {
      this.modalMessage = "";

      // build input.fields w/ checked fields
      this.input.fields = [];
      for (var i = 0; i < this.$refs.fieldsSelector.fields.length; i++) {
        var field = this.$refs.fieldsSelector.fields[i];
        if (field.enabled) {
          this.input.fields.push(field.field);
        }
      }

      // manually pull wClause from subInput component
      this.input.wClause = this.$refs["wClause"].text;
      // if (this.isPostgis) {
      //   this.input.raw = this.$refs["raw"].text;
      // }

      this.input.dest = this.dest;
      this.input.dest2 = this.dest2;
      this.input.dest3 = this.dest3;

      // build input.queryParams only w/ queryParams that have a value set
      var validParams = [];
      for (var i = 0; i < this.queryParams.length; i++) {
        var param = this.queryParams[i];
        if (param.value) {
          validParams.push({ param: param.field, value: param.value });
        }
      }
      this.input.queryParams = validParams;

      var node = {
        object: this.input,
        type: "input"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/updateNode", {
        node: node
      });
      this.isLoading = false;
      if (result.data.success) {
        var updated = {
          type: "input",
          object: result.data.node
        };
        this.hide("input");
        this.hide("input");
        this.$emit("updatedNode", updated);
      } else {
        this.modalMessage = result.data.error;
        this.modalMessageClass = "agModal-errorMessage";
      }
    },

    deleteButton_click() {
      this.$refs.deleteModal.show();
    },

    async confirmDeleteButton_click() {
      this.$refs.deleteModal.hide();
      var node = {
        object: this.input,
        type: "input"
      };
      this.isLoading = true;
      var result = await this.$store.dispatch("nodeStore/deleteNode", {
        node: node
      });
      this.$emit("deletedNode", node);
      this.isLoading = false;
      this.hide("input");
    },
    hide() {
      this.$modal.hide('input');
    },
    async testRaw_click() {
      try {
        this.testRecords = [];
        this.testMessage = "";

        if (!this.input.connection) {
          this.testRecords = [];
          this.testMessage = "A connection must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }

        if (this.input.layer == null) {
          this.testRecords = [];
          this.testMessage = "A layer/object must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }
        var fields = [];
        for (var i = 0; i < this.$refs.fieldsSelector.fields.length; i++) {
          var field = this.$refs.fieldsSelector.fields[i];
          if (field.enabled) {
            fields.push(field.field);
          }
        }

        this.input.raw = this.$refs["raw"].text;
        var result = await Server.post("getRecords", {
          connection: this.input.connection._id,
          layer: this.input.layer,
          fields: fields,
          raw: this.input.raw,
        }).promise;
        console.log("RES ", result);
        if (!result.data.success) throw result.data.error;
        //this is for when the include geometry button is not clicked it wont display the geometry data. Vice Versa, if its checked then it will display geometry data
        if (!this.input.includeGeometry || this.input.includeGeometry === undefined) {
          if (result.data.records.records > 0) {
            console.log("MADE IT!!", result.data.records)
            this.testRecords = result.data.records.value;
          } else {
            const obj = result.data.records.map(a => {
              if (a.geometry)
                delete a.geometry
              return a
            })
            this.testRecords = obj
          }
        } else {
          // console.log("input test ",result);
          this.testRecords = result.data.records;
        }
        if (this.testRecords >= 0) {
          this.testMessage = `Success: ${this.testRecords.records
            } record(s) found`;
          this.testMessageClass = "agModal-successMessage";
        } else {
          this.testMessage = `Success: ${this.testRecords.length
            } record(s) found`;
          this.testMessage = `Success: ${this.testRecords.length
            } record(s) found`;
          this.testMessageClass = "agModal-successMessage";
        }

      } catch (e) {
        this.testRecords = [];
        this.testMessage = e.toString();
        this.testMessageClass = "agModal-errorMessage";
        console.log("Failed 'testWClause' server call. " + e.toString());
      }
    },
    async testWClause_click() {
      try {
        this.testRecords = [];
        this.testMessage = "";

        if (!this.input.connection) {
          this.testRecords = [];
          this.testMessage = "A connection must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }

        if (this.input.layer == null) {
          this.testRecords = [];
          this.testMessage = "A layer/object must be selected";
          this.testMessageClass = "agModal-errorMessage";
          return;
        }
        var fields = [];
        for (var i = 0; i < this.$refs.fieldsSelector.fields.length; i++) {
          var field = this.$refs.fieldsSelector.fields[i];
          if (field.enabled) {
            fields.push(field.field);
          }
        }

        var wClause = this.$refs["wClause"].text;
        // this.input.raw = this.$refs["raw"].text;
        var result = await Server.post("getRecords", {
          connection: this.input.connection._id,
          layer: this.input.layer,
          fields: fields,
          wClause: wClause,
          // raw: this.input.raw
        }).promise;
        if (!result.data.success) throw result.data.error;
        //this is for when the include geometry button is not clicked it wont display the geometry data. Vice Versa, if its checked then it will display geometry data
        if (!this.input.includeGeometry || this.input.includeGeometry === undefined) {
          if (result.data.records.records > 0) {
            console.log("MADE IT!!", result.data.records)
            this.testRecords = result.data.records.value;
          } else {
            const obj = result.data.records.map(a => {
              if (a.geometry)
                delete a.geometry
              return a
            })
            this.testRecords = obj
          }
        } else {
          // console.log("input test ",result);
          this.testRecords = result.data.records;
        }
        if (this.testRecords >= 0) {
          this.testMessage = `Success: ${this.testRecords.records
            } record(s) found`;
          this.testMessageClass = "agModal-successMessage";
        } else {
          this.testMessage = `Success: ${this.testRecords.length
            } record(s) found`;
          this.testMessage = `Success: ${this.testRecords.length
            } record(s) found`;
          this.testMessageClass = "agModal-successMessage";
        }

      } catch (e) {
        this.testRecords = [];
        this.testMessage = e.toString();
        this.testMessageClass = "agModal-errorMessage";
        console.log("Failed 'testWClause' server call. " + e.toString());
      }
    },

    testMessage_click() {
      if (this.testMessageClass.indexOf("success") <= 0) return;
      console.log("TEST ME ", this.testRecords.records);
      if (this.testRecords.records > 0) {
        EventBus.$emit("showAlert", {
          title: `${this.testRecords.records} Record(s)`,
          message: JSON.stringify(this.testRecords.value),
          type: "default"
        });
      }
      EventBus.$emit("showAlert", {
        title: `${this.testRecords.length} Record(s)`,
        message: JSON.stringify(this.testRecords),
        type: "default"
      });
    },

    queryParamValue_change(value, index) {
      var queryParam = this.queryParams[index];
      if (value == "-- None --") {
        queryParam.value = null;
        this.reloadQueryParams++;
      }
    },

    // emitted events

    refreshedSchemas() {
      this.setQueryParams();
    },

    connectionChanged() {
      if (!this.input.connection || this.input.connection.type == "max")
        this.showGeometry = false;
      else this.showGeometry = true;

      this.setQueryParams();
    },

    layerChanged() {
      this.setQueryParams();
    },

    // other

    show() {
      this.setInput();
      // give time for setInput() to pull input from node property
      setTimeout(() => {
        this.reset();
        this.$modal.show('input', { draggable: true });
      }, 250);
    },
    reset() {
      this.modalMessage = "";
      this.modalMessageClass = "";
      this.errorField = "";
      this.testRecords = [];
      this.testMessage = "";
      this.testMessageClass = "";
      if (!this.input.connection || this.input.connection.type == "max")
        this.showGeometry = false;
      else this.showGeometry = true;
      this.init()
      this.setQueryParams();
      var self = this;
      setTimeout(() => {
        self.$refs.fieldsSelector.reset();
      }, 250);
    },

    setInput() {
      if (this.node && this.node.type == "input")
        this.input = this.workflow.inputs.find(
          object => object._id == this.node.object._id
        );
      else this.input = null;
    },

    async setQueryParams() {
      this.queryParams = [];
      if (this.input.layer != null) {
        // make sure to keep != null cause layer can be 0
        var schema = this.input.connection.schemas.find(
          schema => schema.id == this.input.layer
        );
        if (!schema || !schema.queryParams) return;

        for (var i = 0; i < schema.queryParams.length; i++) {
          var param = JSON.parse(JSON.stringify(schema.queryParams[i]));
          if (param.domain) {
            var options = [{ value: "-- None --", text: "-- None --" }];
            for (var j = 0; j < param.domain.length; j++) {
              var domain = param.domain[j];
              options.push({ value: domain.value, text: domain.alias, alias: domain.alias });
            }
            param.domain = options;
          }

          // find and populate from input.queryParams or else push blank field
          if (!this.input.queryParams) this.input.queryParams = [];
          var existing = this.input.queryParams.find(
            a => a.param == param.field
          );
          if (existing) {
            this.queryParams.push({
              field: param.field,
              alias: param.alias,
              domain: param.domain,
              value: existing.value
            });
          } else {
            this.queryParams.push({
              field: param.field,
              alias: param.alias,
              domain: param.domain,
              value: null
            });
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="css">
#agInputModal-fieldsTable {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 155px);
  height: 175px;
  margin: 5px 0px 0px 100px;
  overflow: auto;
  border-collapse: collapse
}

#agInputModal-fieldsTableSpinner {
  position: relative;
  left: -500px;
  top: 75px;
}

#agInputModal-fieldSearch {
  width: calc(100% - 200px);
}

#agInputModal-hideUnselectedFields {
  position: relative;
  left: 111px;
  top: 10px;
  margin-bottom: 5px;
}

#agInputModal-hideUnselectedFields label {
  position: relative;
  top: -2px;
  left: 5px;
}

#agInputModal-testMessage {
  position: relative;
  width: 100%;
  top: -5px;
  text-align: center !important;
}

#agInputModal-testMessage.agModal-successMessage:hover {
  cursor: pointer;
  text-decoration: underline;
}

#agInputModal-testMessage.agModal-successMessage:active {
  opacity: 0.5;
}

#agInputModal-queryParamsTable {
  display: inline-block;
  vertical-align: top;
  width: calc(100% - 195px);
  height: 175px;
  overflow: auto;
  text-align: center;
  border-collapse: collapse
}

.agInputModal-queryParamField {
  width: 375px;
}

.agInputModal-queryParamEquals {
  width: 100px;
  margin-top: 7.5px;

}

.agInputModal-queryParamValue {
  width: 375px;
}
</style>



// WEBPACK FOOTER //
// src/components/nodes/InputModal.vue